export default {
  // KD 客户定制菜单名称（覆盖默认值）
  // 'menu.process.MAN.3': 'MAN.3 项目策划',
  // 'menu.process.SUP.1': 'SUP.1 软件验证与确认',
  'menu.process.SWE.3': 'SWE.3 软件详细设计',
  'menu.process.SWE.4': 'SWE.4 软件单元测试',
  'menu.process.SWE.5': 'SWE.5 软件集成测试',
  'menu.process.SWE.6': 'SWE.6 软件整体测试',
  'menu.process.SUP.9': 'SUP.9 问题管理',
  'menu.process.SVV.1': 'SVV.1 软件验证',
  'menu.process.SVV.2': 'SVV.2 软件确认',
  'menu.process.SPL.2': 'SPL.2 产品发布',
};
